import { render } from "./PeriodicAgeVerificationDialog.vue?vue&type=template&id=772c9264"
import script from "./PeriodicAgeVerificationDialog.vue?vue&type=script&lang=js"
export * from "./PeriodicAgeVerificationDialog.vue?vue&type=script&lang=js"

import "./PeriodicAgeVerificationDialog.vue?vue&type=style&index=0&id=772c9264&lang=scss"
script.render = render

export default script